import { render } from "./stage5Review.vue?vue&type=template&id=18576a8a&scoped=true"
import script from "./stage5Review.vue?vue&type=script&lang=js"
export * from "./stage5Review.vue?vue&type=script&lang=js"

import "./stage5Review.vue?vue&type=style&index=0&id=18576a8a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18576a8a"]])

export default __exports__